import type { PairModel } from '@root/entities/pair'
import type { ServicesApi } from '@root/shared/api'

// TODO: move to user-trading-analytics
export type DistributeRange = readonly [number, number]

export type DistributePairDto = ServicesApi.PairDto & {
  performanceUsd: number
  performancePercent: number
}

export const DISTRIBUTE_RANGES: ReadonlyArray<
  readonly [DistributeRange, string]
> = [
  [[-Infinity, Infinity], 'ALL'],
  [[500, Infinity], '> 500%'],
  [[200, 500], '200% ~ 500%'],
  [[0, 200], '0% ~ 200%'],
  [[-50, 0], '-50% ~ 0%'],
  [[-Infinity, -50], '< -50%'],
]

export const distributeRangeId = (range: DistributeRange) =>
  `${range[0]}:${range[1]}`

export type PairPerformance = {
  pair: PairModel
  performanceUsd: number
  performancePercent: number
}
